import "./search.scss";
import React, { useMemo, useState } from "react";

import { getValue } from "@utils/lodash";
import { debounceSearch } from "@_common/debounceSearch";

export default function Search(props: any) {
  const [searchText, setSearchText] = useState("");

  const debouncedSearch = useMemo(
    () => debounceSearch(props.handleChangeSearch, 500),
    []
  );

  const handleChangeSearch = (e: any) => {
    setSearchText(e.target.value);
    debouncedSearch(e);
  };

  return (
    <section className="common-search-wrapper__filter d-flex align-items-center">
      {props.showSearchTextbox && (
        <>
          <div className="common-search-wrapper__filter-form-group form-group m-0">
            <input
              type="text"
              placeholder={props.placeholder ? props.placeholder : "Search"}
              className="common-search-wrapper__filter-search-input"
              value={searchText}
              onChange={handleChangeSearch}
            />
            <img
              src="/images/search.svg"
              className="img-fluid common-search-wrapper__filter-input-image"
            />

            <img
              src="/images/close-black.svg"
              className="img-fluid common-search-wrapper__filter-image-close"
              onClick={() => {
                props.toggleSearchClose();
              }}
            />
          </div>
        </>
      )}

      <div
        className="common-search-wrapper__filter-container cursor-pointer"
        onClick={() => {
          props.toggleSearchClose();
        }}
      >
        <div className="d-flex">
          <img
            src="/images/search.svg"
            className="img-fluid common-search-wrapper__filter-image"
          />
        </div>
        <h6 className="common-search-wrapper__filter-title">
          {props.searchText || "SEARCH"}
        </h6>
      </div>
    </section>
  );
}
